import {
    RESOURCE_BUNDLE_ACTION_BEGIN,
    RESOURCE_BUNDLE_ACTION_SUCCESS,
    RESOURCE_BUNDLE_ACTION_FAIL,
    SUCCESS,
    ADD_PRODUCT,
    UPDATE_CART
}from './types';
import Helper from '../components/Helper';


export const resourceBundleAction = (formData,actionUrl) => dispatch => {
    const dispatcher=dispatch;
    Helper.customFetchApi(actionUrl,formData,false,RESOURCE_BUNDLE_ACTION_BEGIN,RESOURCE_BUNDLE_ACTION_SUCCESS,RESOURCE_BUNDLE_ACTION_FAIL,dispatcher);
}

// const evtUrl = Helper.actionUrl();
// export const resourceBundleAction = (formData, actionType) => dispatch => {
//     dispatch({
//         type: RESOURCE_BUNDLE_ACTION_BEGIN,
//     })
//     var postURL = actionUrl('/get-resource-bundle');

//     fetch(postURL+`&${formData}`, {
//         credentials: 'include',
//         method: 'POST',
//         body: formData
//     })
//         .then(res => res.json())
//         .then(res => {
//             dispatch({
//                 type: RESOURCE_BUNDLE_ACTION_SUCCESS,
//                 payload: res
//             })
//         })
//         .catch(error => {
//             dispatch({
//                 type: RESOURCE_BUNDLE_ACTION_FAIL,
//                 payload: error
//             })
//             throw error
//         })
// }

